import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";

const AdminLogin = () => {
  const [loggedInUser, setLoggedInUser] = useState(
    localStorage.getItem("loggedInUser") || null
  );
  const navigate = useNavigate(); // Use useNavigate instead of useHistory

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "loggedInUser") {
        setLoggedInUser(event.newValue);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const loginUser = async (event) => {
    event.preventDefault();

    const email = event.target.elements.loginEmail.value;
    const password = event.target.elements.loginPassword.value;

    try {
      const response = await axios.post(
        "https://journey-scape-main.vercel.app/api/auth/adminlogin",
        { email, password }
      );

      const { success, message, user } = response.data;
      if (success) {
        alert(message);
        setLoggedInUser(user.name);
        navigate("/Dashboard"); // Use navigate to redirect after successful login
      } else {
        alert(message);
      }
    } catch (error) {
      console.error(error);
      alert("Failed to login: " + error.message);
    }
  };


  useEffect(() => {
    if (loggedInUser) {
      localStorage.setItem("loggedInUser", loggedInUser);
    } else {
      localStorage.removeItem("loggedInUser");
    }
  }, [loggedInUser]);

  return (
    <div>
      <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <form id="loginForm" onSubmit={loginUser}>
              <div className="form-group">
                <input
                  type="email"
                  className="form-control"
                  id="loginEmail"
                  required
                />
                <label htmlFor="loginEmail" className="animated-label">
                  Email
                </label>
              </div>
              <div className="form-group">
                <input
                  type="password"
                  className="form-control"
                  id="loginPassword"
                  required
                />
                <label htmlFor="loginPassword" className="animated-label">
                  Password
                </label>
              </div>
              <button type="submit" className="btn btn-primary btn-block w-100">
                Login
              </button>
            </form>
            <p className="mt-3">
              Don't have an account? <Link to="/Adminregister">Register</Link>
            </p>
          </li>
      </ul>
    </div>
  );
};

export default AdminLogin;
